import { IEnv } from './env.type'

export const environment: IEnv = {
  PRODUCTION: false,
  API_PREFIX: 'https://dev.api.phoenix.tiagl.in',
  SOCKET_PREFIX: 'wss://dev.api.phoenix.tiagl.in',
}
